<template>
  <div class="manage-skill-modal modal" role="alert">
    <div
      class="manage-skill-modal__wrapper"
      :class="[
        addonsSelected.length > 0 && 'manage-skill-modal__wrapper--pb-0',
      ]"
    >
      <button
        class="manage-skill-modal__close"
        @click="$emit('close-manage-skill-dive-modal')"
      >
        <XIcon class="manage-skill-modal__close--icon" />
      </button>
      <template>
        <div
          :class="[
            'manage-skill-modal__title-wrapper',
            isLoading && 'manage-skill-modal__loading',
          ]"
        >
          <h5 class="manage-skill-modal__title">Manage Skill Dive</h5>
        </div>
        <div
          :class="[
            'manage-skill-modal__content',
            isLoading && 'manage-skill-modal__loading',
          ]"
        >
          <div
            v-if="validAddons.length > 0"
            class="manage-skill-modal__learning-areas"
          >
            <div class="manage-skill-modal__subtitle">Add a learning area</div>
            <div class="manage-skill-modal__description">
              <span
                >You have the {{ listOfLearningAreas.join(' and ') }} learning
                area{{ listOfLearningAreas.length > 1 ? 's' : '' }}.</span
              >
              Explore other learning areas for just {{ priceForAll }} each!
            </div>
            <div class="manage-skill-modal__addons-wrapper">
              <div
                v-for="addon in validAddons"
                :key="addon.item_code"
                class="manage-skill-modal__addon-border"
                :class="`manage-skill-modal__addon-border--${addon.item_code}`"
                @click="handleAddonSelected(addon.item_code)"
              >
                <div class="manage-skill-modal__addon-background">
                  <div class="manage-skill-modal__addon">
                    <div class="manage-skill-modal__addons-content">
                      <input
                        class="manage-skill-modal__checkbox"
                        type="checkbox"
                        :checked="
                          addonsSelected.find(
                            selected => selected.code === addon.item_code
                          )
                        "
                      />
                      <span>{{ getLearningAreaName(addon.item_code) }}</span>
                    </div>
                    <div class="manage-skill-modal__addons-content">
                      <span
                        class="manage-skill-modal__addons-content manage-skill-modal__addons-content--bolded"
                        >{{ addon.due_today.total }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="manage-skill-modal__add-hours">
            <div class="manage-skill-modal__subtitle">
              Extend your learning time
            </div>
            <div class="manage-skill-modal__description">
              <span>
                You have {{ remainingTime }} Skill Dive hour{{
                  remainingTime > 1 ? 's' : ''
                }}
                remaining.
              </span>
              Add hours for uninterrupted learning.
            </div>
            <div
              :class="[
                'manage-skill-modal__add-hours-wrapper',
                skillDiveAddHoursPreviewLoading &&
                  'manage-skill-modal__add-hours-wrapper--disabled',
              ]"
            >
              <div
                :class="[
                  'manage-skill-modal__add-hours-background',
                  skillDiveAddHoursPreviewLoading &&
                    'manage-skill-modal__add-hours-background--disabled',
                ]"
                @click="handleAddHoursSelected()"
              >
                <div class="manage-skill-modal__add-hours-checkbox">
                  <input
                    class="manage-skill-modal__checkbox"
                    type="checkbox"
                    :checked="addHoursSelected"
                  />
                  <div
                    class="manage-skill-modal__add-hours-checkbox-label-wrapper"
                  >
                    <div
                      class="manage-skill-modal__add-hours-checkbox-label-text"
                    >
                      Add more hours
                    </div>
                    <div
                      class="manage-skill-modal__add-hours-checkbox-label-subtitle"
                    >
                      Add hours in increments of
                      {{ addHoursMinQuantity }}
                    </div>
                  </div>
                </div>
                <div
                  :class="[
                    'manage-skill-modal__add-hours-quantity-wrapper',
                    addHoursSelected &&
                      'manage-skill-modal__add-hours-quantity-wrapper--selected',
                  ]"
                >
                  <PillBadge
                    v-if="addHoursSelected"
                    sober-black
                    class="manage-skill-modal__cart-amount-items"
                  >
                    <div
                      v-if="showAddHoursRemove"
                      class="manage-skill-modal__add-hours-quantity-cta-remove"
                    >
                      <TrashIcon
                        class="manage-skill-modal__add-hours-quantity-cta-remove--icon"
                        @click.stop="handleAddHoursDecrease()"
                      />
                    </div>
                    <div
                      v-if="!showAddHoursRemove"
                      class="manage-skill-modal__add-hours-quantity-cta-decrease"
                    >
                      <MinusIcon
                        class="manage-skill-modal__add-hours-quantity-cta-decrease--icon"
                        @click.stop="handleAddHoursDecrease()"
                      />
                    </div>
                    <div
                      class="manage-skill-modal__add-hours-quantity-cta-detail"
                    >
                      {{ `${addHoursQuantity} hrs` }}
                    </div>
                    <div
                      class="manage-skill-modal__add-hours-quantity-cta-increase"
                    >
                      <PlusIcon
                        class="manage-skill-modal__add-hours-quantity-cta-increase--icon"
                        @click.stop="handleAddHoursIncrease()"
                      />
                    </div>
                  </PillBadge>
                  <div class="manage-skill-modal__add-hours-price">
                    <vue-loaders
                      v-if="addHoursPriceLoading"
                      class="manage-skill-modal__add-hours-price-spinner"
                      name="ball-clip-rotate"
                      color="#fff"
                    ></vue-loaders>
                    <span v-else>{{ `$${addHoursPrice}` }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="manage-skill-modal__add-hours-little-letters">
              * Added hours expire at the end of your subscription and will not
              carry over if you cancel instead of auto-renewing.
            </div>
          </div>
        </div>
        <ModalGenericCartFooter
          :cartTotalItems="addonsSelected.length"
          :cartTotalAmount="skillDiveModalCartTotal"
          paddingSum="60"
          @buy-action="handleSaveChanges"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import CONSTANTS from '@/constants'
import { XIcon, TrashIcon, PlusIcon, MinusIcon } from 'vue-feather-icons'
import PillBadge from '@/components/shared/PillBadge.vue'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import ModalGenericCartFooter from '@/components/modals/ModalGenericCartFooter.vue'

const {
  SKILL_DIVE: { SKILL_DIVE_ADD_HOURS, SKILL_DIVE_ADD_HOURS_MIN_VALUE },
} = CONSTANTS

export default {
  name: 'ManageSkillDiveModal',
  components: {
    XIcon,
    TrashIcon,
    PlusIcon,
    MinusIcon,
    PillBadge,
    ActionLoader,
    ModalGenericCartFooter,
  },
  props: {
    validAddons: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    userCurrentPlan: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      addonsSelected: [],
      addOnPriceTotal: 0,
      addHoursSelected: false,
      addHoursQuantity: 0,
      addHoursMinQuantity: SKILL_DIVE_ADD_HOURS_MIN_VALUE,
      addOnFixedPrice: {
        price_string: '$99',
        price: 99,
        price_cents: 9900,
      },
      skillDiveAddHoursPreviewLoading: false,
      skillDiveManageLoading: false,
    }
  },
  computed: {
    ...mapState({
      labExperienceUserAccess: state => state.auth.labExperienceUserAccess,
      addHoursPriceLoading: state => state.subscriptions.addHoursPriceLoading,
    }),
    ...mapGetters({
      skillDiveAddHoursPreview:
        'subscriptions/getSkillDiveAddHoursPreviewPurchase',
    }),
    priceForAll() {
      return (
        this.validAddons?.[0]?.due_today?.total ||
        this.addOnFixedPrice.price_string
      )
    },
    priceCentsForAll() {
      return (
        this.validAddons?.[0]?.due_today?.total_cents ||
        this.addOnFixedPrice.price_cents
      )
    },
    listOfLearningAreas() {
      const learningAreas = ['Cyber Security', 'Cloud', 'Networking']
      const plansToBuy =
        this.validAddons?.map(
          addon => CONSTANTS.SKILL_DIVE.ITEM_CODES[addon.item_code]
        ) || []
      return learningAreas.filter(area => !plansToBuy.includes(area))
    },
    showAddHoursRemove() {
      return this.addHoursQuantity === SKILL_DIVE_ADD_HOURS_MIN_VALUE
    },
    addHoursPrice() {
      return this.skillDiveAddHoursPreview
    },
    remainingTime() {
      return Math.round(this.labExperienceUserAccess.available_time / 3600) || 0
    },
    skillDiveModalCartTotal() {
      return (
        this.addOnPriceTotal / 100 +
        (this.addHoursQuantity > 0 ? this.addHoursPrice : 0)
      ).toFixed(2)
    },
    addHoursPackQuantity() {
      return this.addHoursQuantity / SKILL_DIVE_ADD_HOURS_MIN_VALUE
    },
  },
  watch: {
    addHoursQuantity(newValue) {
      if (
        newValue === SKILL_DIVE_ADD_HOURS_MIN_VALUE &&
        !this.addonsSelected.find(item => item.code === SKILL_DIVE_ADD_HOURS)
      ) {
        this.handleAddonSelected(SKILL_DIVE_ADD_HOURS)
      } else if (newValue < SKILL_DIVE_ADD_HOURS_MIN_VALUE) {
        this.handleAddonSelected(SKILL_DIVE_ADD_HOURS)
      }
    },
  },
  created() {
    this.getSkillDiveAddHoursPreviewPurchase()
  },
  methods: {
    ...mapActions('auth', ['userMeOnContent']),
    ...mapActions('subscriptions', [
      'addAddonsForSubscription',
      'skillDiveAddHoursPurchase',
      'skillDiveAddHoursPreviewPurchase',
    ]),
    getLearningAreaName(item_code) {
      return CONSTANTS.SKILL_DIVE.ITEM_CODES[item_code]
    },
    handleAddonSelected(item_code) {
      if (this.isLoading) return
      const exists = this.addonsSelected.find(addon => addon.code === item_code)
      // if item is SD LA - remove
      if (exists && exists.code !== SKILL_DIVE_ADD_HOURS) {
        this.addonsSelected = this.addonsSelected.filter(
          addon => addon.code !== item_code
        )
        this.addOnPriceTotal -= this.priceCentsForAll
      }
      // if item is SD addHours - remove
      if (
        exists &&
        exists.code === SKILL_DIVE_ADD_HOURS &&
        this.addHoursQuantity === 0
      ) {
        this.addonsSelected = this.addonsSelected.filter(
          addon => addon.code !== item_code
        )
      }
      // if item is not on Manage SD Cart - add
      if (!exists) {
        this.addonsSelected.push({ code: item_code })
        if (item_code !== SKILL_DIVE_ADD_HOURS)
          this.addOnPriceTotal += this.priceCentsForAll
      }
    },
    handleAddHoursSelected() {
      this.addHoursSelected = !this.addHoursSelected
      if (this.addHoursSelected) {
        this.handleAddHoursIncrease()
      } else {
        this.addHoursQuantity = 0
        this.getSkillDiveAddHoursPreviewPurchase()
      }
    },
    handleAddHoursIncrease() {
      this.addHoursQuantity += SKILL_DIVE_ADD_HOURS_MIN_VALUE
      if (this.addHoursQuantity > SKILL_DIVE_ADD_HOURS_MIN_VALUE) {
        this.getSkillDiveAddHoursPreviewPurchase()
      }
    },
    handleAddHoursDecrease() {
      this.addHoursQuantity -= SKILL_DIVE_ADD_HOURS_MIN_VALUE
      if (this.addHoursQuantity === 0) {
        this.addHoursSelected = false
      }
      this.getSkillDiveAddHoursPreviewPurchase()
    },
    async getSkillDiveAddHoursPreviewPurchase() {
      this.skillDiveAddHoursPreviewLoading = true
      await this.skillDiveAddHoursPreviewPurchase(
        this.addHoursPackQuantity === 0 ? 1 : this.addHoursPackQuantity
      )
      this.skillDiveAddHoursPreviewLoading = false
    },
    async handleSaveChanges() {
      this.skillDiveManageLoading = true
      const addonsSelected = this.addonsSelected.filter(
        item => item.code !== SKILL_DIVE_ADD_HOURS
      )
      const skillDiveSubscriptionId = this.userCurrentPlan
        ?.skill_dive_subscription?.id
      if (addonsSelected.length > 0) {
        const payload = {
          id: skillDiveSubscriptionId,
          addons: addonsSelected,
        }
        await this.addAddonsForSubscription(payload)
        await this.userMeOnContent()
      }
      if (this.addHoursPackQuantity > 0)
        await this.skillDiveAddHoursPurchase(this.addHoursPackQuantity)
      this.skillDiveManageLoading = false
      this.$emit('save-skill-modal-changes')
      this.$emit('close-manage-skill-dive-modal')
    },
  },
}
</script>

<style lang="scss" scoped>
.manage-skill-modal {
  $this: &;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 402;
  background: rgba(113, 113, 113, 0.8);
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  &__wrapper {
    display: flex;
    gap: 25px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    margin: auto;
    background: var(--glass-mid-gray);
    color: var(--black);
    width: 100%;
    margin-top: 60px;
    height: auto;
    border-radius: 24px;
    padding: 30px;
    overflow-y: auto;
    max-width: 630px;
    overflow-x: hidden;
    transition: all 1s ease-in-out;
    @include mobile {
      width: 45%;
      margin-top: auto;
    }
    &:before {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      border-radius: 24px;
      background: var(--black);
      z-index: -1;
      top: 0;
      left: 0;
    }
    &--pb-0 {
      padding-bottom: 0;
    }
  }
  &__content {
    display: flex;
    flex-flow: column;
    gap: 30px;
  }
  &__close {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 30px;
    top: 30px;
    background: none;
    border: none;
    cursor: pointer;
    color: var(--white);
    padding: 0;
    &:hover {
      .upgrade__close--icon {
        fill: var(--orange);
      }
    }
    &--icon {
      fill: var(--white);
    }
  }
  &__title-wrapper {
    text-align: center;
    margin: 20px 0;
  }
  &__title {
    margin: 0;
    color: var(--white);
    font-size: rem(40px);
    line-height: rem(52px);
    font-family: var(--font-bold);
  }
  &__subtitle {
    color: var(--white);
    font-family: var(--font-bold);
    font-size: rem(20px);
    line-height: rem(26px);
  }
  &__description {
    color: var(--light-blue-gray);
    font-size: rem(16px);
    line-height: rem(24px);
    margin: 5px 0px 20px 0px;
    font-weight: 450;
    span {
      color: var(--white);
      font-family: var(--font-bold);
      font-weight: 700;
    }
  }
  &__addons {
    &-wrapper {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    &-content {
      display: flex;
      gap: 10px;
      align-items: center;
      font-weight: 500;
      font-size: rem(18px);
      line-height: rem(24px);
      &--bolded {
        font-weight: 700;
        font-size: rem(24px);
        line-height: rem(32px);
      }
    }
  }
  &__addon {
    &-border {
      background: var(--mid-gray-gradient);
      padding: 1px;
      border-radius: 20px;
      transition: 1.2s all ease;
      height: fit-content;
      &--skill_dive_cyber {
        background: rgba(187, 133, 255, 1);
        background: linear-gradient(
          160deg,
          rgba(122, 123, 127, 0.7) 20%,
          rgba(62, 63, 73, 0) 75%,
          rgb(187, 133, 255, 1) 110%
        );
      }
      &--skill_dive_networking {
        background: rgba(250, 215, 64, 1);
        background: linear-gradient(
          160deg,
          rgba(122, 123, 127, 0.7) 20%,
          rgba(62, 63, 73, 0) 75%,
          rgb(250, 215, 64, 1) 110%
        );
      }
      &--skill_dive_cloud {
        background: rgba(136, 169, 255, 1);
        background: linear-gradient(
          160deg,
          rgba(122, 123, 127, 0.7) 20%,
          rgba(62, 63, 73, 0) 75%,
          rgb(136, 169, 255, 1) 110%
        );
      }
    }
    &-background {
      background: var(--mid-gray-gradient);
      border-radius: 20px;
      transition: 0.2 all ease-in;
      &:hover {
        background: var(--light-gray);
      }
    }
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    align-items: center;
    color: var(--white);
    height: 62px;
  }
  &__checkbox {
    border: 1px solid var(--mid-gray-dark);
    border-radius: 8px;
    appearance: none;
    background: none;
    color: var(--white);
    padding: 11px;
    width: 30px;
    height: 30px;
    &:hover:not([disabled]) {
      border: 1px solid var(--white);
      cursor: pointer;
    }
    &:checked {
      border: 1px solid var(--positive-light);
      background: var(--mid-gray-dark-25);
      color: var(--white);
      position: relative;
      display: inline-block;
      &::before {
        transform: rotate(40deg);
        content: '';
        position: absolute;
        width: 1px;
        height: 9px;
        background-color: var(--white);
        left: 15px;
        top: 10px;
      }
      &::after {
        transform: rotate(-45deg);
        content: '';
        position: absolute;
        width: 1px;
        height: 4px;
        background-color: var(--white);
        left: 11px;
        top: 14px;
      }
    }
  }
  &__loading {
    opacity: 0.4;
  }
  &__add-hours {
    &-wrapper {
      &--disabled {
        cursor: progress;
      }
    }
    &-background {
      background: var(--mid-gray-gradient);
      border-radius: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px;
      min-height: 60px;
      color: var(--white);
      cursor: pointer;
      &:hover {
        background: var(--light-gray);
      }
      &--disabled {
        pointer-events: none;
      }
    }
    &-checkbox {
      display: flex;
      align-items: center;
      gap: 10px;
      &-label {
        &-text {
          font-size: rem(18px);
          font-style: normal;
          font-weight: 500;
          line-height: rem(24px);
        }
        &-subtitle {
          color: var(--light-blue-gray);
          font-size: rem(12px);
          font-style: normal;
          font-weight: 450;
          line-height: rem(14px);
        }
      }
    }
    &-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      color: var(--white);
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
    }
    &-little-letters {
      color: var(--light-blue-gray);
      font-size: rem(10px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(12px);
      margin-top: 10px;
    }
    &-quantity {
      &-wrapper {
        display: flex;
        gap: 10px;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        max-width: 175px;
        .pill--sober-black {
          width: unset;
        }
        &--selected {
          justify-content: space-between;
        }
      }
      &-cta-remove,
      &-cta-decrease,
      &-cta-increase {
        display: flex;
        align-items: center;
        svg {
          height: 16px;
        }
      }
      &-cta-detail {
        white-space: nowrap;
        text-transform: lowercase;
      }
    }
    &-price {
      font-weight: 700;
      font-size: rem(24px);
      line-height: rem(32px);
      &-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
